import type { Components } from "@mui/material/styles";
import { buttonRootStyles, containedMap, ghostMap, ghostUnderlineMap, outlinedMap } from "./styles";

// Please follow guidelines https://www.figma.com/design/zzvO7fdaTfLvgTSrb6ypCs/wikifolio-UI-Library?node-id=0-847&p=f&m=dev

export const MuiButton: Components["MuiButton"] = {
    defaultProps: {
        variant: "contained",
        color: "gray",
    },
    styleOverrides: {
        root: {
            ...buttonRootStyles,
            variants: [
                {
                    props: { variant: "contained", color: "gray" },
                    style: containedMap.gray,
                },
                {
                    props: { variant: "contained", color: "green" },
                    style: containedMap.green,
                },
                {
                    props: { variant: "contained", color: "whiteAlpha" },
                    style: containedMap.whiteAlpha,
                },

                {
                    props: { variant: "outlined", color: "gray" },
                    style: outlinedMap.gray,
                },
                {
                    props: { variant: "outlined", color: "green" },
                    style: outlinedMap.green,
                },
                {
                    props: { variant: "ghost", color: "gray" },
                    style: ghostMap.gray,
                },
                {
                    props: { variant: "ghost", color: "green" },
                    style: ghostMap.green,
                },
                {
                    props: { variant: "ghost-underline", color: "gray" },
                    style: ghostUnderlineMap.gray,
                },
                {
                    props: { variant: "ghost-underline", color: "green" },
                    style: ghostUnderlineMap.green,
                },
            ],
        },
        endIcon: {
            marginRight: 0,
        },
        sizeExtraSmall: {
            paddingInline: "16px",
            minWidth: "32px",
            height: "32px",
            fontWeight: 600,
            lineHeight: "24px",
        },
        sizeSmall: {
            paddingInline: "16px",
            minWidth: "40px",
            height: "40px",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
        },
        sizeMedium: {
            paddingInline: "24px",
            minWidth: "48px",
            height: "48px",
            fontSize: "16px",
            fontWeight: 600,
        },
        sizeLarge: {
            paddingInline: "32px",
            minWidth: "56px",
            fontSize: "16px",
            fontWeight: 600,
            height: "56px",
        },
    },
};
